import ApiService from '../api-service'
import { CreateUserData, ResponseCreateUser, ResponseEditUser, ResponsePermissionUsers, UpdateUserData } from './types'

export const getPermissionUsers = () => ApiService.get<undefined, ResponsePermissionUsers>('/permissions/users', {})

export const createUser = (data: CreateUserData) => ApiService.post<CreateUserData, ResponseCreateUser>('/permissions/admins', {
  data
})

export const updateUser = (data: UpdateUserData) => ApiService.post<UpdateUserData, ResponseEditUser>(`/permissions/admins/${data.id}`, {
  data
})

